import React from 'react';
import './Contact.css';
import ImageLoader from '../common/ImageLoader/ImageLoader';
import postaIcon from '../../assets/posta.png';


const Contact = () => {
  return (
    <div className="contact container fade-in">
      <h1>Kapcsolat</h1>
      <a href="tel:+36703757181" className="contact-item">
        <i className="fas fa-phone"></i>
        <p>+36 70 3757 181</p>
      </a>
      <a href="mailto:info@berkimelinda.hu" className="contact-item">
        <i className="fas fa-envelope"></i>
        <p>info@berkimelinda.hu</p>
      </a>
      <div className="row mt-3">
        <a href="https://www.facebook.com/berkimelindaenglish/" className="contact-item-circle" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-facebook-f"></i>
        </a>
        <a href="https://www.linkedin.com/in/melinda-berki-a1675789/" className="contact-item-circle" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-linkedin-in"></i>
        </a>
      </div>
      <ImageLoader src={postaIcon} alt="Posta" className="post-icon" />
    </div>
  );
};


export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js